import { Paginacion, Wait, Guid } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

import * as Chats from '@/__env/lib/MercadoLibre/Chats';
import { Chat } from '@/__env/lib/MercadoLibre/Chats';
import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';
import { Adjunto } from '@/__env/lib/MercadoLibre/Chats/Mensajes/Mensaje.lib';
import { ArchivoTemporal } from '@/__env/lib/Varios/Archivos/Temporal.nav';
import { Controlador as ControladorPrincipal } from '../controlador';
import { ControladorBarrasLaterales } from '@/views/a-chat-2/pc/lista/sala/barra-principal/ventas/controlador';


export class ControladorChatActivo
{
    constructor ( x: Chat )
    {
        this.Chat = x;
        this.NuevoMensaje = new NuevoMensaje( this.Chat );
        this.ControladorBarrasLaterales = new ControladorBarrasLaterales( this.Chat.Cliente );
    }

    public Chat: Chat = null;
    public Mensajes: Mensaje[] = [];
    public ControladorBarrasLaterales: ControladorBarrasLaterales;
    
    public async Iniciar ()
    {
        this.Mensajes.clear();
        this.Vista.Estado = 'cargando';
        let msjs = await this.Chat.CargarMensajes();
        for ( let msj of msjs )
        {

        }
        await Wait( 500 );
        this.Mensajes.push( ...msjs );
        this.MarcarLeido();
        await this.Chat.ObtenerCantidadDisponible();
        this.Vista.Estado = 'ok';
    }

    public async CargarMasMensajes ()
    {
        let msjs = await this.Chat.CargarMasMensajes( this.Mensajes[0] );
        this.Mensajes.unshift( ...msjs );
    }

    public async CerrarChatActivo ()
    {

        ControladorPrincipal.CerrarChatActivo();
    }

    public Vista: VistaBase = new VistaBase();
    public NuevoMensaje: NuevoMensaje;

    public AgregarMensaje ( mensaje: any )
    {

        let existe = this.Mensajes.find( x => x.Id == mensaje.id );
        if ( existe )
        {
            this.RecargarMensaje( mensaje );

        } else
        {
            let maje = new Mensaje( mensaje );
            this.Mensajes.push( maje );
            this.MarcarLeido();
            this._onNuevoMensaje.dispatch( null );
        }

    }

    public RecargarMensaje ( mensaje: any )
    {
        this._onRecargarMensaje.dispatchAsync( mensaje );
    }

    public MarcarLeido ()
    {
        let mensajes = this.Mensajes.filter( x => !x.Propio && !x.Leido && x.Enviado );
        if ( mensajes.hasRows() )
        {
            let msj = {
                cuenta: this.Chat.Cuenta,
                ids: mensajes.map( x => x.IdExterna )
            };

            ControladorPrincipal.Socket.emit( 'XWML204', ControladorPrincipal.SocketCript( msj ) );
        }
    }

    private _onRecargarMensaje = new SimpleEventDispatcher<any>();
    public get onRecargarMensaje () { return this._onRecargarMensaje.asEvent(); }

    private _onNuevoMensaje = new SimpleEventDispatcher<any>();
    public get onNuevoMensaje () { return this._onNuevoMensaje.asEvent(); }

    public ScrollYFocus ()
    {
        this._onScrollYFocus.dispatch();
    }
    private _onScrollYFocus = new SignalDispatcher();
    public get onScrollYFocus () { return this._onScrollYFocus.asEvent(); }
}

export class NuevoMensaje
{
    constructor ( Chat: Chat )
    {
        this.Chat = Chat;
    }

    protected Chat: Chat = null;
    public Archivos: Adjunto[] = [];
    public Contenido: string = '';

    public get Valido ()
    {
        return this.Contenido.trim().length > 0 || this.Archivos.hasRows();
    }

    public EnviandoMensaje: boolean = false;
    public SubiendoArchivo: boolean = false;
    public async AgregarArchivo ( x: File ): Promise<'demasiado-grande' | 'error' | 'ok'>
    {

        if ( x.size / 1000000 > 25 )
        {
            return 'demasiado-grande';
        }

        this.SubiendoArchivo = true;
        await Wait( 100 );
        let d = await ArchivoTemporal.Crear( x, this.Chat.Cuenta );
        if ( !d )
        {
            this.SubiendoArchivo = false;
            return 'error';
        }

        let a = new Adjunto();
        a.ArchivoProvisional = d.Nombre;
        a.Archivo = d.URL;
        a.IdProvisional = Guid.create().toString();
        a.Nombre = x.name;
        a.Tipo = x.type;
        this.Archivos.push( a );
        this.SubiendoArchivo = false;

        return 'ok';
    }

    public async AgregarArchivoEstatico ( data: { Nombre: string; Ruta: string; } ): Promise<'demasiado-grande' | 'error' | 'ok'>
    {

        this.SubiendoArchivo = true;
        await Wait( 100 );
        let d = await Mensaje.SubirEstatico( data.Ruta, this.Chat.Cuenta );
        if ( !d )
        {
            this.SubiendoArchivo = false;
            return 'error';
        }

        let a = new Adjunto();
        a.ArchivoProvisional = d.Nombre;
        a.Archivo = d.URL;
        a.IdProvisional = Guid.create().toString();
        a.Nombre = data.Nombre;
        a.Tipo = d.Tipo;
        this.Archivos.push( a );
        this.SubiendoArchivo = false;

        return 'ok';
    }

    public async AgregarArchivoUrl ( data: { Nombre: string; Ruta: string; } ): Promise<'demasiado-grande' | 'error' | 'ok'>
    {

        this.SubiendoArchivo = true;
        await Wait( 100 );
        let d = await Mensaje.SubirURL( data.Ruta, this.Chat.Cuenta );
        if ( !d )
        {
            this.SubiendoArchivo = false;
            return 'error';
        }

        let a = new Adjunto();
        a.ArchivoProvisional = d.Nombre;
        a.Archivo = d.URL;
        a.IdProvisional = Guid.create().toString();
        a.Nombre = data.Nombre;
        a.Tipo = d.Tipo;
        this.Archivos.push( a );
        this.SubiendoArchivo = false;

        return 'ok';
    }

    public EliminarArchivo ( x: Adjunto )
    {
        let idx = this.Archivos.findIndex( a => a.IdProvisional == x.IdProvisional );
        if ( idx > -1 )
        {
            this.Archivos.splice( idx, 1 );
        }


    }


    EnviarArchivoEStatico ( archivo: string )
    {

    }

    EnviarMensaje ()
    {
        if ( this.EnviandoMensaje )
            return;

        this.EnviandoMensaje = true;

        try
        {

            let mensaje = new Mensaje();
            mensaje.Adjuntos.push( ... this.Archivos );
            for ( let arc of mensaje.Archivos )
            {
                arc.Archivo = arc.URLProvisional;
            }

            mensaje.Id = Mensaje.NuevoGuid();
            mensaje.Contenido = this.Contenido;
            mensaje.Propio = true;
            mensaje.Enviando = true;
            mensaje.Chat = this.Chat.Id;

            this.Contenido = '';
            this.Archivos.clear();

            let msj = mensaje.getJson();
            ControladorPrincipal.Socket.emit( 'XWML200', ControladorPrincipal.SocketCript( msj ), ( x: Buffer ) =>
            {
                let ms = JSON.parse( ControladorPrincipal.SocketDecript( x ) );
                if ( ms )
                {
                    console.log( ms );
                    ControladorPrincipal.Activo.RecargarMensaje( ms );
                }

            } );

            ControladorPrincipal.Activo.Mensajes.push( mensaje );

        } catch ( error )
        {

        }

        this.EnviandoMensaje = false;


    }
}